import React, { Component } from 'react';
import { translate } from 'react-i18next';
import CBModal from './CBModal';
import CBMediaQuery from './CBMediaQuery';
import { getStyle } from '../../utils/utils';

// "Show all fields" dialog for mobile list cards. Lists every desktop column and
// its value so no data is lost on mobile. Built on the shared CBModal (white sheet).
// Props: modalIsOpen, closeModal, title, fields = [{ label, value }]
class CBFieldsDialog extends Component {
  render() {
    const { modalIsOpen, closeModal, title, fields, t } = this.props;
    return (
      <CBModal
        modalIsOpen={modalIsOpen}
        closeModal={closeModal}
        title={title}
        hideCancelButton
        isValid
        submitText={t('close', { ns: 'common' })}
        submitForm={closeModal}
      >
        <CBMediaQuery>
          {screenSize => (
            <div style={getStyle(screenSize, styles, 'list')}>
              {(fields || []).map((field, idx) => (
                <div key={idx} style={getStyle(screenSize, styles, 'row')}>
                  <span style={getStyle(screenSize, styles, 'label')}>{field.label}</span>
                  <span style={getStyle(screenSize, styles, 'value')}>{field.value}</span>
                </div>
              ))}
            </div>
          )}
        </CBMediaQuery>
      </CBModal>
    );
  }
}

const styles = {
  default: {
    list: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 32px',
    },
    row: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'baseline',
      gap: 16,
      padding: '10px 0',
      borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
    },
    label: {
      color: 'rgba(0, 0, 0, 0.55)',
      fontSize: 14,
      flexShrink: 0,
    },
    value: {
      color: '#000000',
      fontSize: 15,
      fontFamily: 'TitilliumWeb-SemiBold',
      textAlign: 'right',
      wordBreak: 'break-word',
    },
  },
  small: {
    list: {
      padding: '0 16px',
    },
  },
};

export default translate()(CBFieldsDialog);
